import React, { useState, useEffect } from "react";
import Case from "./Case";
import { AllCases } from "./AllCases";

let total = 0;

function App() {
  const [keyword, setKeyword] = useState("");

  const [data, setData] = useState([]);
  const [sortType, setSortType] = useState("probability");

  useEffect(() => {
    const sortArray = (type) => {
      const types = {
        probability: "probability",
        good: "good",
        bad: "bad",
        antiProbability: "probability",
        antiGood: "good",
        antiBad: "bad",
      };
      const sortProperty = types[type];
      const sorted = [...AllCases].sort(
        (a, b) => b[sortProperty] - a[sortProperty]
      );
      if (type === "antiProbability" || type === "good" || type === "bad") {
        sorted.reverse();
      }
      setData(sorted);
    };
    sortArray(sortType);
  }, [sortType]);

  return (
    <div className="App">
      <div className="container my-5 ">
        <h3 className="text-center display-4">Cubeshape Parity</h3>
        <h5 className="text-center text-secondary">
          By Eva Kato &#183;{" "}
          <a
            className="link-primary"
            href="https://www.youtube.com/watch?v=pXXr87kwZuI"
            target="_blank"
          >
            Link to Video Tutorial
          </a>
        </h5>
        <br></br>
        <div className="row">
          <div className="input-group mb-3 col-lg-4 col-md-4">
            <input
              type="text"
              className="form-control"
              placeholder="Search keyword"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-default"
              onChange={(e) => setKeyword(e.target.value)}
            ></input>
          </div>
          <div className="col-lg-5 col-md-5"></div>
          <div className="dropdown col-lg-3 col-md-3">
            <select
              className="form-control"
              onChange={(e) => setSortType(e.target.value)}
            >
              <option value="probability">Highest Probability</option>
              <option value="antiProbability">Lowest Probability</option>
              <option value="antiGood">Highest Best Slice</option>
              <option value="good">Lowest Best Slice</option>
              <option value="antiBad">Highest Worst Slice</option>
              <option value="bad">Lowest Worst Slice</option>
            </select>
          </div>
        </div>

        <div class="row align-items-start">
          {data.map((cspCase) =>
            cspCase.name.toLowerCase().includes(keyword.toLowerCase()) ? (
              <Case
                name={cspCase.name}
                odd={cspCase.odd}
                even={cspCase.even}
                oddPar={cspCase.oddPar}
                evenPar={cspCase.evenPar}
                top={cspCase.top}
                good={cspCase.good}
                bad={cspCase.bad}
                bottom={cspCase.bottom}
                probability={((cspCase.probability / 3678) * 100).toFixed(3)}
              ></Case>
            ) : (
              <div style={{ display: "none" }}></div>
            )
          )}
        </div>
        <p className="text-center mt-4">
          Please <a href="mailto:evakato14@gmail.com">contact me</a> for any
          edits.
        </p>
      </div>
    </div>
  );
}

export default App;
